export enum LoadingState {
    Loading = 'loading',
    Loaded = 'loaded',
    Error = 'error'
}

export interface ObservableState<T, R = any> {
    response?: T;
    loadingState: LoadingState;
    error?: any;
    additionalData?: R;

}
